import React, { ReactElement, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { DialogContent, Grid, IconButton, useMediaQuery, useTheme, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DialogTransition } from "../components/DialogTransition";
import CloseIcon from "@mui/icons-material/Close";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
}));

export interface CustomDialogrops {
    open: boolean;
    onClosed: () => void;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    fullWidth?: boolean;
}

export function CustomDialog(props: React.PropsWithChildren<CustomDialogrops>): ReactElement {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [open, setOpen] = React.useState(props.open);

    useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleTransitionEnd = () => {
        if (!open) {
            props.onClosed();
        }
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="custom-dialog-title"
            open={open}
            fullScreen={fullScreen}
            maxWidth={props.maxWidth}
            fullWidth={props.fullWidth}
            TransitionComponent={DialogTransition}
            keepMounted
            onTransitionEnd={handleTransitionEnd}
        >
            <DialogContent>
                <StyledIconButton
                    aria-label="close"
                    onClick={handleClose}
                >
                    <CloseIcon />
                </StyledIconButton>
                {props.fullWidth ? (
                    <Box sx={{ width: '100%' }}>
                        {props.children}
                    </Box>
                ) : (
                    <Grid container spacing={0} direction="row" justifyContent="center" alignItems="center">
                        <Grid>{props.children}</Grid>
                    </Grid>
                )}
            </DialogContent>
        </Dialog>
    );
}
